<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="!hasClass('site-logo') && !hasClass('banner-collection-blocks'); else noContainerBanners">
    <ng-container *ngIf="hasClass('banner-is-clickable'); else bannerTemplate">
      <cx-generic-link class="banner-is-clickable" [url]="data.linkLoc"> </cx-generic-link>
      <ng-container *ngTemplateOutlet="bannerTemplate"></ng-container
    ></ng-container>
  </ng-container>

  <ng-template #bannerTemplate>
    <div
      [pyMedia]="data.media"
      [useAsBackgroundImage]="hasBannerBackground(data)"
      [ngClass]="{
        'banner-holder d-flex flex-column row no-gutters': true,
        'no-content': !data?.content && !data?.headline
      }"
    >
      <ng-container *ngIf="hasClass('banner-content-left'); else isContentRight">
        <ng-container [ngTemplateOutlet]="contentleft"></ng-container>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #noContainerBanners>
    <ng-container *ngIf="hasClass('banner-collection-blocks'); else siteLogo">
      <ng-container *ngIf="!hasClass('footer-promise-banner'); else footerPromiseBanner">
        <div class="image-wrapper">
          <img [pyMedia]="data.media" />
        </div>
        <div
          (click)="showBlocksBannerText = !showBlocksBannerText"
          class="banner-collection-blocks-content"
          [ngClass]="{ 'p-4': hasClass('banner-collection-blocks') && data.content, 'show-text': showBlocksBannerText }"
        >
          <div class="banner-text-holder" *ngIf="data.content">
            <ng-container *ngIf="showBlocksBannerText" [ngTemplateOutlet]="bannerText"></ng-container>
            <div class="show-text-content" *ngIf="!showBlocksBannerText">
              <div class="headline" [innerHTML]="data.headline"></div>
              <span>{{ data.leadTextLoc }}</span>
            </div>
          </div>
          <i class="read-more" *ngIf="!showBlocksBannerText" nz-icon nzType="arrow-right"></i>
        </div>
        <i
          (click)="showBlocksBannerText = !showBlocksBannerText"
          class="close-icon"
          *ngIf="showBlocksBannerText"
          nz-icon
          nzType="close-circle"
        ></i>
      </ng-container>

      <ng-template #footerPromiseBanner>
        <div class="footer-promise-banner-wrapper d-flex flex-column flex-md-row flex-xl-column align-items-start">
          <div class="image-wrapper">
            <img [pyMedia]="data.media" />
          </div>
          <div class="pt-6 pt-md-0 pt-xl-6 pl-0 pl-md-6 pl-xl-0">
            <div class="banner-text-holder" *ngIf="data.content">
              <div class="footer-text" *ngIf="data.content" [innerHTML]="data.content"></div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>

  <ng-template #siteLogo>
    <!-- The header logo banner should link to startpage, but the footer banner logo should not -->
    <ng-container *ngIf="data.slots?.includes && data.slots.includes('footer_logo_slot_local'); else templateHeaderLogo">
      <div class="image-wrapper">
        <img [pyMedia]="data.media" />
      </div>
    </ng-container>
    <ng-template #templateHeaderLogo>
      <cx-generic-link [url]="'/'">
        <div class="image-wrapper">
          <img [pyMedia]="data.media" />
        </div>
      </cx-generic-link>
    </ng-template>
  </ng-template>

  <ng-template #isContentRight>
    <ng-container *ngIf="hasClass('banner-content-right') || hasClass('banner-content-right-3'); else isLinkBanner">
      <ng-container [ngTemplateOutlet]="contentRight"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #isLinkBanner>
    <ng-container *ngIf="hasClass('banner-link'); else isContentDefault">
      <ng-container [ngTemplateOutlet]="linkBanner"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #isContentDefault>
    <ng-container [ngTemplateOutlet]="default"></ng-container>
  </ng-template>

  <ng-template #default>
    <div
      [ngClass]="{
        'col-12 offset-0 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 px-5':
          !hasClass('banner-content-right-2')
      }"
    >
      <ng-container [ngTemplateOutlet]="bannerText"></ng-container>
      <div *ngIf="data.linkLoc?.trim() && !hasClass('banner-is-clickable')" class="mt-4 d-flex justify-content-center">
        <cx-generic-link [url]="data.linkLoc" [target]="getTarget(data)">
          <div class="btn" [class]="buttonClass">
            {{ data.leadTextLoc }}
          </div>
        </cx-generic-link>
      </div>
    </div>
  </ng-template>

  <ng-template #contentleft>
    <div class="banner-content container">
      <ng-container
        [ngTemplateOutlet]="bannerText"
        [ngTemplateOutletContext]="{ data: data, classes: 'col-12 col-md-8 col-lg-10 col-xl-8 px-4 px-md-0' }"
      ></ng-container>
      <div *ngIf="data.linkLoc?.trim()" class="mt-4 px-4 px-md-0 action-button">
        <cx-generic-link [url]="data.linkLoc" [target]="getTarget(data)">
          <div class="btn" [class]="buttonClass">
            {{ data.leadTextLoc }}
          </div>
        </cx-generic-link>
      </div>
    </div>
  </ng-template>

  <ng-template #contentRight>
    <div class="d-block d-md-flex right-container container flex-column flex-md-row">
      <div class="col-12 col-md-6 media">
        <div class="image-wrapper">
          <img [pyMedia]="data.media" />
        </div>
      </div>

      <div class="col-12 col-md-6 align-self-center flex-row text">
        <ng-container
          [ngTemplateOutlet]="bannerText"
          [ngTemplateOutletContext]="{ data: data, classes: 'mt-4 mt-lg-0' }"
        ></ng-container>
        <cx-generic-link *ngIf="data.linkLoc?.trim()" [url]="data.linkLoc" [target]="getTarget(data)">
          <div class="banner-content-right-button mt-4 btn" [class]="buttonClass">
            {{ data.leadTextLoc }}
            <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
          </div>
        </cx-generic-link>
      </div>
    </div>
  </ng-template>

  <ng-template #bannerText let-classes="classes">
    <div [ngClass]="classes" class="banner-text-holder" *ngIf="data.headline || data.content">
      <div class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></div>
      <div class="content" *ngIf="data.content" [innerHTML]="data.content"></div>
    </div>
  </ng-template>

  <ng-template #linkBanner let-classes="classes">
    <cx-generic-link [url]="data.linkLoc">
      <div [ngClass]="classes" class="banner-text-holder">
        <img [pyMedia]="data.media" />
        <span>{{ data.leadTextLoc }} <i nz-icon nzType="arrow-right"></i></span>
      </div>
    </cx-generic-link>
  </ng-template>
</ng-container>
